<div class="notification" [ngClass]="type">
    <div class="icon">
        <i class="pi" [ngClass]="{
  'pi-check-circle': type === 'success',
  'pi-exclamation-circle': type === 'error',
  'pi-info-circle': type === 'info',
  'pi-exclamation-triangle': type === 'warn' || type === 'warning'
}"></i>
    </div>
    <div class="content d-flex flex-column">
        <div class="title">{{ type }}</div>
        <div class="message">{{ formattedMessage }}</div>
    </div>
    <button class="close-btn" (click)="close()">×</button>
</div>